<template>
  <div class="filter-buttons">
    <div class="flex flex-wrap gap-2">
      <button 
        v-for="option in filteredOptions" 
        :key="option.value"
        class="px-3 py-1.5 rounded-full text-sm transition-colors flex items-center gap-1"
        :class="isOptionSelected(option.value) 
          ? 'bg-primary text-primary-foreground' 
          : 'bg-secondary text-secondary-foreground hover:bg-secondary/80'"
        @click="toggleOption(option.value)"
      >
        <span>{{ option.displayValue }}</span>
        <span 
          v-if="filter.uiConfig?.showCount && option.count !== undefined" 
          class="text-xs opacity-80"
        >
          ({{ getOptionCount(option.value) }})
        </span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useFilters } from '~/layers/base/composables/useFilters'

const props = defineProps({
  filter: {
    type: Object,
    required: true
  },
  activeValue: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['update:value', 'clear'])

const { getFilterOptionCount } = useFilters()

// Get count of vehicles for a filter option
const getOptionCount = (optionValue: string): number => {
  if (!props.filter) return 0
  return getFilterOptionCount(props.filter.name, optionValue)
}

// Filter options to only show those with count > 0
const filteredOptions = computed(() => {
  if (!props.filter || !props.filter.data || !Array.isArray(props.filter.data)) {
    return []
  }
  
  return props.filter.data.filter((option: any) => {
    return getOptionCount(option.value) > 0
  })
})

// Check if an option is selected
const isOptionSelected = (value: string) => {
  return Array.isArray(props.activeValue) && props.activeValue.includes(value)
}

// Toggle an option selection
const toggleOption = (value: string) => {
  if (!Array.isArray(props.activeValue)) {
    emit('update:value', [value])
    return
  }
  
  // Special handling for condition filter - always allow toggling
  const isConditionFilter = props.filter?.name === 'condition'
  
  if (isOptionSelected(value)) {
    const newValue = props.activeValue.filter(v => v !== value)
    emit('update:value', newValue.length ? newValue : undefined)
  } else {
    emit('update:value', [...props.activeValue, value])
  }
}
</script>
